<script setup>
import {ref} from "vue";
import startupsService from "@/services/ecosystem/startups.service";
import {startupStatusClasses, startupStatusLabels} from "@/constants/needs";
import {getNumberWithNoun} from "@/helpers/string";

const startupId = ref(null);
const showModal = ref(false);
const needs = ref([]);

async function getData() {
    const {data} = await startupsService.getSubmittedNeeds(startupId.value);
    needs.value = data;
}

function open(id) {
    needs.value = [];
    startupId.value = id;
    showModal.value = true;
    getData();
}

defineExpose({
    open
});
</script>

<template>
    <Modal v-model="showModal" hideFooter :title="`Submitted To ${getNumberWithNoun('Need', needs.length)}`" modal-class="modal-v2 modal-v2--md">
        <ul class="list-submission">
            <li v-for="need in needs" :key="need.id">
                <div class="list-submission__info">
                    <h6 class="heading6">
                        <a :href="`/needs/${need.id}`" target="_blank">{{need.name}}</a>
                    </h6>
                    <Clamp>
                        <p>{{need.description}}</p>
                        <template #after="{ toggle, expanded, clamped }">
                            <a v-if="expanded" class="link-normal" style="font-size: 14px" @click="toggle">less</a>
                            <a v-if="clamped" class="link-normal" style="font-size: 14px" @click="toggle">more</a>
                        </template>
                    </Clamp>
                </div>
                <div v-if="need.sponsor_label" class="top-category" :class="`top-category--${need.sponsor_category}`">{{need.sponsor_label}}</div>
                <div class="list-submission__status">
                    <span
                        class="status-plate status-plate--strong"
                        :class="startupStatusClasses[need.submit_status]"
                    >
                        {{ startupStatusLabels[need.submit_status] }}
                    </span>
                </div>
            </li>
        </ul>
    </Modal>
</template>

<style scoped>

</style>
